/**
 * Translations added for:
 *   - Forgot password / reset password flow (AuthPage, ResetPasswordPage)
 *   - 2FA login prompt (AuthPage)
 *   - Blog Packs pricing page (was hardcoded English)
 *
 * Primary user language is Slovak; English included as the universal fallback.
 * Other locales fall back to English via translations.js merge logic.
 */
export const authExtrasTranslations = {
  en: {
    // Auth page extras
    auth_forgot_link: "Forgot password?",
    auth_forgot_title: "Reset your password",
    auth_forgot_desc: "Enter your email — we'll send you a reset link.",
    auth_forgot_cta: "Send reset link",
    auth_forgot_sent: "If this email is registered, a reset link has been sent. Check your inbox.",
    auth_back: "Back to sign in",
    auth_2fa_title: "Two-factor authentication",
    auth_2fa_desc: "Enter the 6-digit code from your authenticator app (or a backup code).",
    auth_2fa_code: "6-digit code or backup code",
    auth_2fa_verify: "Verify & sign in",
    auth_referral_banner: "You were invited via a campaign — sign up to claim 3 free ad credits.",
    // Reset password page
    rp_title: "Choose a new password",
    rp_sub: "Pick something you don't use on any other site.",
    rp_new_pwd: "New password",
    rp_confirm: "Confirm new password",
    rp_min_len: "Password must be at least 6 characters.",
    rp_mismatch: "Passwords do not match.",
    rp_submit: "Reset password",
    rp_done_title: "Password updated",
    rp_done_sub: "You can now sign in with your new password.",
    rp_goto_login: "Sign in",
    // Blog Packs
    bp_eyebrow: "SEO Blog Packs",
    bp_hero_title: "100 SEO articles.",
    bp_hero_sub: "Let PulseAI Engine™ write, optimize, and auto-publish SEO articles with backlinks to your site. You pick the rhythm — we handle the rest.",
    bp_my_packs: "My Packs",
    bp_best_value: "Best value",
    bp_one_time: "one-time",
    bp_articles: "articles",
    bp_per_article: "article",
    bp_get: "Get",
    bp_month: "month",
    bp_for: "for",
    bp_sub_title_prefix: "Subscription",
    bp_sub_note: "Auto-refills monthly · cancel anytime · best long-term SEO compounding",
    bp_subscribe: "Subscribe →",
    bp_turbo_title: "Turbo Delivery add-on",
    bp_turbo_note: "Upgrade your latest pack to 10 articles/day (vs 1-3). Purchase after a pack.",
    bp_add_turbo: "Add Turbo",
    bp_roi_eyebrow: "What €49/mo looks like in 12 months",
    bp_roi_title: "The math of compounding SEO",
    bp_back: "Back to TopRankPulse",
    bp_perk_1: "AI-generated SEO articles (500-800 words)",
    bp_perk_2: "2 contextual backlinks to your domain per article",
    bp_perk_3: "Unique target keyword + meta description",
    bp_perk_4: "Auto-published to TopRankPulse blog (indexed by Google)",
    bp_perk_5: "Translated into 26 languages automatically",
    bp_perk_6: "Configurable delivery rhythm — 1, 3 or 10 articles/day",
  },
  sk: {
    auth_forgot_link: "Zabudnuté heslo?",
    auth_forgot_title: "Obnovenie hesla",
    auth_forgot_desc: "Zadajte svoj e-mail — pošleme vám odkaz na obnovenie.",
    auth_forgot_cta: "Poslať odkaz",
    auth_forgot_sent: "Ak je tento e-mail registrovaný, poslali sme odkaz na obnovenie. Skontrolujte schránku.",
    auth_back: "Späť na prihlásenie",
    auth_2fa_title: "Dvojfaktorové overenie",
    auth_2fa_desc: "Zadajte 6-ciferný kód z autentifikačnej aplikácie (alebo záložný kód).",
    auth_2fa_code: "6-ciferný kód alebo záložný kód",
    auth_2fa_verify: "Overiť a prihlásiť",
    auth_referral_banner: "Boli ste pozvaní cez kampaň — registráciou získate 3 bezplatné kredity na reklamy.",
    rp_title: "Zvoľte si nové heslo",
    rp_sub: "Vyberte heslo, ktoré nepoužívate na inej stránke.",
    rp_new_pwd: "Nové heslo",
    rp_confirm: "Potvrďte nové heslo",
    rp_min_len: "Heslo musí mať minimálne 6 znakov.",
    rp_mismatch: "Heslá sa nezhodujú.",
    rp_submit: "Obnoviť heslo",
    rp_done_title: "Heslo bolo zmenené",
    rp_done_sub: "Môžete sa teraz prihlásiť s novým heslom.",
    rp_goto_login: "Prihlásiť sa",
    bp_eyebrow: "SEO Blog Balíky",
    bp_hero_title: "100 SEO článkov.",
    bp_hero_sub: "Nechajte PulseAI Engine™ písať, optimalizovať a auto-publikovať SEO články so spätnými odkazmi na váš web. Vy si zvolíte rytmus — zvyšok robíme my.",
    bp_my_packs: "Moje balíky",
    bp_best_value: "Najvýhodnejšie",
    bp_one_time: "jednorazovo",
    bp_articles: "článkov",
    bp_per_article: "článok",
    bp_get: "Získať",
    bp_month: "mesiac",
    bp_for: "za",
    bp_sub_title_prefix: "Predplatné",
    bp_sub_note: "Auto-obnovovanie mesačne · zrušiť kedykoľvek · najlepší dlhodobý SEO efekt",
    bp_subscribe: "Predplatiť →",
    bp_turbo_title: "Turbo doručenie — doplnok",
    bp_turbo_note: "Povýšte posledný balík na 10 článkov/deň (namiesto 1-3). Kupuje sa po balíku.",
    bp_add_turbo: "Pridať Turbo",
    bp_roi_eyebrow: "Čo ukážu €49/mes. za 12 mesiacov",
    bp_roi_title: "Matematika kumulatívneho SEO",
    bp_back: "Späť na TopRankPulse",
    bp_perk_1: "AI-generované SEO články (500-800 slov)",
    bp_perk_2: "2 kontextové spätné odkazy na vašu doménu na každý článok",
    bp_perk_3: "Unikátny cieľový keyword + meta popis",
    bp_perk_4: "Auto-publikácia na TopRankPulse blogu (indexované Googlom)",
    bp_perk_5: "Automatický preklad do 26 jazykov",
    bp_perk_6: "Nastaviteľný rytmus doručenia — 1, 3 alebo 10 článkov/deň",
  },
  cs: {
    auth_forgot_link: "Zapomenuté heslo?",
    auth_forgot_title: "Obnovení hesla",
    auth_forgot_desc: "Zadejte svůj e-mail — pošleme vám odkaz pro obnovení.",
    auth_forgot_cta: "Odeslat odkaz",
    auth_forgot_sent: "Pokud je tento e-mail registrovaný, odkaz pro obnovení byl odeslán.",
    auth_back: "Zpět na přihlášení",
    auth_2fa_title: "Dvoufaktorové ověření",
    auth_2fa_desc: "Zadejte 6místný kód z autentifikační aplikace.",
    auth_2fa_code: "6místný kód nebo záložní kód",
    auth_2fa_verify: "Ověřit a přihlásit",
    rp_title: "Zvolte si nové heslo",
    rp_submit: "Obnovit heslo",
    rp_done_title: "Heslo bylo změněno",
    rp_done_sub: "Nyní se můžete přihlásit s novým heslem.",
    rp_goto_login: "Přihlásit se",
    bp_eyebrow: "SEO Blog Balíčky",
    bp_hero_title: "100 SEO článků.",
    bp_one_time: "jednorázově",
    bp_articles: "článků",
    bp_per_article: "článek",
    bp_get: "Získat",
  },
  de: {
    auth_forgot_link: "Passwort vergessen?",
    auth_forgot_title: "Passwort zurücksetzen",
    auth_forgot_cta: "Link senden",
    auth_back: "Zurück zur Anmeldung",
    auth_2fa_title: "Zwei-Faktor-Authentifizierung",
    auth_2fa_code: "6-stelliger Code oder Backup-Code",
    auth_2fa_verify: "Überprüfen & anmelden",
    bp_eyebrow: "SEO Blog-Pakete",
    bp_one_time: "einmalig",
    bp_articles: "Artikel",
    bp_get: "Holen",
  },
};
